export default function returnValidNumber(value: string): number | null {
  if (!value) return null;

  let cleaned = value.trim();

  // Remove pontos (milhares) e troca vírgula por ponto
  cleaned = cleaned.replace(/\./g, '').replace(',', '.');

  const num = Number(cleaned);

  return isNaN(num) ? null : Number(num.toFixed(2));
}
